import React from 'react';

import ErrorIcon from '@atlaskit/icon/glyph/error';

import { ErrorStyled, IconStyled } from './Error.styled';

const Error = ({ errorMessage }: { errorMessage: string }) => {
  return (
    <ErrorStyled>
      <IconStyled>
        <ErrorIcon
          label='Error icon'
          primaryColor='var(--ds-icon-danger, var(--ds-fb-icon-danger))'
          size='small'
        />
      </IconStyled>
      <div>{errorMessage}</div>
    </ErrorStyled>
  );
};

export default Error;
